// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AssignedDocuments_tabs_1FnLF","spinAround":"AssignedDocuments_spinAround_1bQ0k"};